
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ChartBar } from "lucide-react";

interface DashboardStatsProps {
  pollStats: {
    totalPolls: number;
    activePolls: number;
  };
}

export const DashboardStats = ({ pollStats }: DashboardStatsProps) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center text-lg">
          <ChartBar className="mr-2 h-5 w-5 text-nation-blue" />
          My Polling Stats
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div>
            <div className="text-sm font-medium text-muted-foreground">Total Polls Answered</div>
            <div className="text-2xl font-bold">{pollStats.totalPolls}</div>
          </div>
          <div>
            <div className="text-sm font-medium text-muted-foreground">Active Polls</div>
            <div className="text-2xl font-bold">{pollStats.activePolls}</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
